import { DeviceDataType } from '../device-types'
export interface LiveViewObject {
    port: number
    enable: boolean
    allowed_networks: {
        sso: string[]
        login: string[]
    }
    default_password: string
    default_username: string
    trusted_jwt_keys: [string, string][]
    default_access_token: string
    max_reads_per_second: number
    max_logins_per_second: number
    stream_timeout_client: number
    stream_timeout_server: number
    max_concurrent_streams: number
    max_updates_per_second: number
    max_snapshots_per_second: number
}

export const getLiveViewAccessToken = (device: DeviceDataType): string | null | undefined => {
    // console.log(device, 'device live view get access token')
    return device?.config?.diff?.live?.default_access_token || device?.config?.base?.live?.default_access_token
}

export const getLiveViewObject = (device: DeviceDataType): LiveViewObject | null => {
    return device?.config?.base?.live
}
